/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_FailedInputs */

const en_checkout_failed = /** @type {(inputs: Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkout Failed`)
};

const es_checkout_failed = /** @type {(inputs: Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallo en el pago`)
};

const fr_checkout_failed = /** @type {(inputs: Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du paiement`)
};

const de_checkout_failed = /** @type {(inputs: Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasse fehlgeschlagen`)
};

const ja_checkout_failed = /** @type {(inputs: Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チェックアウトに失敗しました`)
};

const zh_checkout_failed = /** @type {(inputs: Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结账失败`)
};

const ar_checkout_failed = /** @type {(inputs: Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشلت عملية الدفع`)
};

const id_checkout_failed = /** @type {(inputs: Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkout Gagal`)
};

const it_checkout_failed = /** @type {(inputs: Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkout Fallito`)
};

const ru_checkout_failed = /** @type {(inputs: Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при оформлении заказа`)
};

const pt_checkout_failed = /** @type {(inputs: Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha no Checkout`)
};

const ko_checkout_failed = /** @type {(inputs: Checkout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제 실패`)
};

/**
* | output |
* | --- |
* | "Checkout Failed" |
*
* @param {Checkout_FailedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const checkout_failed = /** @type {((inputs?: Checkout_FailedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_FailedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkout_failed(inputs)
	if (locale === "es") return es_checkout_failed(inputs)
	if (locale === "fr") return fr_checkout_failed(inputs)
	if (locale === "de") return de_checkout_failed(inputs)
	if (locale === "ja") return ja_checkout_failed(inputs)
	if (locale === "zh") return zh_checkout_failed(inputs)
	if (locale === "ar") return ar_checkout_failed(inputs)
	if (locale === "id") return id_checkout_failed(inputs)
	if (locale === "it") return it_checkout_failed(inputs)
	if (locale === "ru") return ru_checkout_failed(inputs)
	if (locale === "pt") return pt_checkout_failed(inputs)
	return ko_checkout_failed(inputs)
});